<template>
  <div>
     <v-row class="pt-12" v-if="images.length < 1">
    <v-col
      v-for="(personImg , pid) in randomPeople"
      :key="pid+Math.random()+Math.random()"
      class="d-flex child-flex"
      cols="4"
    >
      <v-img
      style="border-radius:50%"
        :src="personImg"
        :lazy-src="personImg"
        aspect-ratio="1"
        class="grey lighten-2"
      >
        <template v-slot:placeholder>
          <v-row
            class="fill-height ma-0"
            align="center"
            justify="center"
          >
            <v-progress-circular
              indeterminate
              color="grey lighten-5"
            ></v-progress-circular>
          </v-row>
        </template>
      </v-img>
    </v-col>
  </v-row>
   <v-row class="pt-12" v-else>
    <v-col
      v-for="(image, ind) in images"
      :key="ind+Math.random()+Math.random()"
      class="d-flex child-flex"
      cols="4"
    >
      <v-img
      style="border-radius:50%"
        :src="getApiUrl+'/images/'+folder+'/'+getUserCompany.emis+'/'+image"
        aspect-ratio="1"
        class="grey lighten-2"
      >
        <template v-slot:placeholder>
          <v-row
            class="fill-height ma-0"
            align="center"
            justify="center"
          >
            <v-progress-circular
              indeterminate
              color="grey lighten-5"
            ></v-progress-circular>
          </v-row>
        </template>
      </v-img>
    </v-col>
  </v-row>
  </div>
</template>

<script>

export default {
  props:['images','folder'],
  computed: {
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getAppName() {
      return this.$store.getters.getAppName;
    },
    getApiUrl() {
      return this.$store.getters.getApiUrl;
    },
    getUserCompany() {
      return this.$store.getters.getUserCompany;
    }
  },
  data() {
    return {
     randomPeople:[
       "https://scontent-jnb1-1.xx.fbcdn.net/v/t1.0-9/67658319_10215331962834867_6747748150091448320_n.jpg?_nc_cat=107&ccb=3&_nc_sid=8bfeb9&_nc_ohc=QE4Z4A-Nf0UAX-MQqBv&_nc_ht=scontent-jnb1-1.xx&oh=28ee6556a402a1ecd594f43db76cc9e8&oe=60566764",
       "https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/35af6a41332353.57a1ce913e889.jpg",
       "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRLiJgqOlg5pypAgHs5ZI5LeyyhfpttonoDoA&usqp=CAU",
       "https://static.seattletimes.com/wp-content/uploads/2013/09/2021826838-300x0.jpg",
       "https://pbs.twimg.com/media/D8dDZukXUAAXLdY.jpg",
       "https://scontent-jnb1-1.xx.fbcdn.net/v/t1.0-9/48372172_10213721861783347_4681428311560159232_n.jpg?_nc_cat=110&ccb=3&_nc_sid=8bfeb9&_nc_ohc=PO_PgYGZJKgAX_N5FBB&_nc_ht=scontent-jnb1-1.xx&oh=fc93436dc1a579b173282fc8cf68bc93&oe=605572CC"

     ]
    };
  }
};
</script>

<style>
</style>